<template>


    <div class="relatorios">

        <el-form label-position="top">
            <c-panel title="FILTROS">

                <div>
                    <el-row :gutter="10" class="u-mt-10">
                        <el-col :xs="24" :sm="20" :md="20">
                            <el-form-item label="Instituição" key="instituicao" v-if="([4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo)))">
                                <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                    <el-option key="all" label="Todos" value=""> </el-option>
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>                            
                            <div class="style-form" v-if="[0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))">
                                <label class="el-form-item__label">Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                            </div>                            
                        </el-col>
                        <el-col :xs="24" :sm="4" :md="4">
                            <el-form-item label="Período Letivo" key="periodo">
                                <el-select ref="periodo_id" v-model="filtro.periodo_id">
                                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </div>

            </c-panel>
        </el-form>

        <div class="u-mt-10">
            <el-row>
                <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                    <el-button @click="renderRelatorioQuilombolas('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
                    <el-button @click="renderRelatorioQuilombolas('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
                    <el-button @click="renderRelatorioQuilombolas('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
                </el-col>
            </el-row>
        </div>

    </div>


</template>
<script>

export default {
data: () => ({

    loadingButtonPdf: false,
    loadingButtonHtml: false,
    loadingButtonExcel: false,
    ref: [],
    filtro: {
        periodo_id: '',
        instituicao_id: ''
    }

}),
mounted () {

    this.filtro.periodo_id = this.$store.state.config.periodo.id;

    if([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))){

        this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
    }
    
},
methods: {
    renderRelatorioQuilombolas(tipo){


        this.ref = [
            { nome: 'Instituição', valor: (([0, 1, 3, 9, 12].includes(Number(this.$store.state.user.tipo))) ? this.$store.state.config.instituicao.id : this.$refs.instituicao_id.selected.label)},
            { nome: 'Período', valor: this.$refs.periodo_id.selected.label }
        ];

        if(tipo == 'pdf'){

            this.loadingButtonPdf = true;
            this.renderPdfRelatorioQuilombolas();

        }else if(tipo == 'html'){

            this.loadingButtonHtml = true;
            this.renderHtmlRelatorioQuilombolas();

        }else if(tipo == 'excel'){

            this.loadingButtonExcel = true;
            this.renderExcelRelatorioQuilombolas();
        }
    },
    renderPdfRelatorioQuilombolas(){

        window.eventBus.$emit('print', {url: '/api/pdf/renderRelatorioQuilombola/pdf', param: {ref: this.ref, filtros: this.filtro }});
        this.loadingButtonPdf = false;
    },
    async renderHtmlRelatorioQuilombolas(){

        try{

            let response = await this.getCodAutorizacaoRelatorioHtml();

            window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`);

            this.loadingButtonHtml = false;

        }catch(e){

            window.eventBus.$emit('alert', {msg: 'Erro ao gerar relatório.', type: 'warning'});
        }

    },
    getCodAutorizacaoRelatorioHtml(){

        return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/quilombola`, {ref: this.ref, filtros: this.filtro}, this.$store.getters.getHeaderAuth);
    },
    formatData(field, size = null){

        //TRATA OS INPUTS - LETRA MAIÚCULA

        if(!this.filtro[field])
            return false;

        if(size && this.filtro[field].length < size)
            this.filtro[field] = '';

        this.filtro[field] = this.filtro[field].toUpperCase();

        this.filtro[field] = this.$removerAcentos(this.filtro[field]);
    },
    renderExcelRelatorioQuilombolas(){

        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioQuilombola/excel`, { param: {ref: this.ref, filtros: this.filtro} }, this.$store.getters.getHeaderAuthExcel).then(response => {

            this.loadingButtonExcel = false;

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'relatorio.xlsx');
            document.body.appendChild(link);
            link.click();

        }).catch((error) => { this.$store.commit('throwException', error); });

    },
}
}
</script>